import {fixedDec, roundDec} from './util';

// Number.MAX_VALUE = 1.7976931348623157e308
const MAX_EXP = 308;
// Number.MIN_VALUE = 5e-324
const MIN_EXP = -324;

/**
 * This fork is necessary because uPlot's default incrs max out at 10^(+/-32). incrs are
 * used to generate the tick values for the axes by determining how much they can increment by.
 *
 * This means that for plots with values outside of that range, the ticks wouldn't show up.
 * This fork extends the range to Number.MAX_VALUE and Number.MIN_VALUE so that ticks will always show up.
 *
 * The rest of this file is copied more or less straight from uPlot, only changing the min/max exponents.
 * https://github.com/leeoniya/uPlot/blob/master/src/utils.js#L382C1-L407
 *
 * Existing open issue: https://github.com/leeoniya/uPlot/issues/1116
 */

function guessDec(num: number) {
  return (('' + num).split('.')[1] || '').length;
}

function genIncrs(
  base: number,
  minExp: number,
  maxExp: number,
  mults: number[]
) {
  let incrs = [];

  let multDec = mults.map(guessDec);

  for (let exp = minExp; exp < maxExp; exp++) {
    let expa = Math.abs(exp);
    let mag = roundDec(Math.pow(base, exp), expa);

    for (let i = 0; i < mults.length; i++) {
      let _incr = base === 10 ? +`${mults[i]}e${exp}` : mults[i] * mag;
      let dec = (exp >= 0 ? 0 : expa) + (exp >= multDec[i] ? 0 : multDec[i]);
      let incr = base === 10 ? _incr : roundDec(_incr, dec);
      incrs.push(incr);
      fixedDec.set(incr, dec);
    }
  }

  return incrs;
}

const allMults = [1, 2, 2.5, 5];
// ...0.01, 0.02, 0.025, 0.05, 0.1, 0.2, 0.25, 0.5
const decIncrs = genIncrs(10, MIN_EXP, 0, allMults);
// 1, 2, 2.5, 5, 10, 20, 25, 50...
const oneIncrs = genIncrs(10, 0, MAX_EXP, allMults);
const numIncrs = decIncrs.concat(oneIncrs);

export function getIncrs(isTimeAxis: boolean) {
  // https://github.com/leeoniya/uPlot/blob/master/src/uPlot.js#L1148
  if (isTimeAxis) {
    // actually just let uPlot handle the time axis incrs, it does that correctly
    return undefined;
  }
  return numIncrs;
}
